import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=370789e3&scoped=true&"
import script from "./PopupMenu.vue?vue&type=script&lang=ts&"
export * from "./PopupMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=370789e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370789e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
